import React from 'react'

const LogoIconfinder = ({ style = {}, ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <g clipPath="url(#clip0_3_139)">
        <path
          d="M14.7791 12.2527C14.1432 12.2527 13.5376 12.3825 12.9871 12.6159C13.7334 12.8769 14.2683 13.5869 14.2683 14.4225C14.2683 15.4815 13.412 16.3374 12.3539 16.3374C11.5183 16.3374 10.8083 15.8033 10.5473 15.0557C10.3131 15.607 10.1841 16.2127 10.1841 16.8481C10.1841 19.3867 12.2417 21.4431 14.7786 21.4431C17.3164 21.4431 19.3736 19.3863 19.3736 16.8481C19.374 14.3112 17.3168 12.2527 14.7791 12.2527Z"
          fill="black"
        />
        <path
          d="M20.9867 6.87824C18.0335 5.04318 14.3431 4.57298 10.9538 5.74545L10.956 5.74329C12.5741 4.56478 14.5674 3.86855 16.7239 3.86855C17.9291 3.86855 19.0744 4.0562 20.139 4.45565C20.2081 4.48024 20.2991 4.49663 20.3405 4.49663C20.5946 4.49663 20.7813 4.32192 20.7826 4.07475C20.7835 3.90608 20.7002 3.76631 20.5924 3.66667C17.7734 1.07153 14.7788 0 14.7788 0C8.096 2.67192 3.18139 9.13604 3.04033 16.522C2.97994 18.6232 3.48162 20.7658 4.61009 22.7187C5.27958 23.8786 6.1173 24.8807 7.07322 25.712C5.24334 24.8988 3.64511 23.5206 2.56668 21.6536C1.96406 20.6097 1.55296 19.5235 1.36704 18.4032C1.35453 18.3307 1.32261 18.244 1.3019 18.2078C1.17508 17.9869 0.930489 17.9127 0.715666 18.0361C0.569 18.1194 0.490059 18.2617 0.458569 18.4045C-0.38088 22.1445 0.188961 25.2737 0.188961 25.2737C5.92707 29.7902 14.1365 30.7784 20.6506 27.0173C23.7151 25.2469 25.6804 22.3067 26.3064 19.0848L26.3081 19.0891C26.519 21.0816 26.1247 23.1544 25.0467 25.0222C24.4446 26.0653 23.7099 26.9651 22.8317 27.6872C22.7747 27.7334 22.7152 27.805 22.6949 27.8404C22.5681 28.0595 22.6255 28.3105 22.8394 28.4344C22.9852 28.5193 23.1474 28.5159 23.2868 28.4732C26.9448 27.33 29.3708 25.2715 29.3708 25.2715C30.3953 18.1694 27.2752 10.7032 20.9867 6.87824ZM14.7792 24.5058C9.42161 24.5058 5.07899 20.7507 5.07899 16.1161C5.07899 15.623 5.13119 15.139 5.22566 14.6684C7.23887 12.6043 10.7636 11.2321 14.7792 11.2321C18.7944 11.2321 22.3192 12.6043 24.3324 14.6684C24.4277 15.139 24.4799 15.623 24.4799 16.1161C24.4799 20.7507 20.1369 24.5058 14.7792 24.5058Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_139">
          <rect width="29.5623" height="29.3333" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LogoIconfinder
